export function getShippingMethods(deliveryOptions, code) {
  const {
    errors,
    deliveries
  } = deliveryOptions;
  const deliveryMethods = [...deliveries.deliveryMethods, ...deliveries.pickupMethods];
  const {
    hasShippingZipCodeError,
    hasShippingSubdivisionError,
    hasShippingDestinationError
  } = errors;
  const hasTimeSlots = deliveryMethods.some(opt => opt.hasTimeSlots);
  if (hasShippingSubdivisionError || hasShippingDestinationError || hasShippingZipCodeError || hasTimeSlots) {
    return;
  }
  const shippingMethods = deliveryMethods.map(_ref => {
    let {
      title,
      price,
      options,
      subtitle
    } = _ref;
    const subOption = options[0];
    return {
      label: title,
      amount: price.toString(),
      identifier: subOption == null ? void 0 : subOption.id,
      detail: subtitle || ''
    };
  });
  const selectedShippingMethod = shippingMethods.findIndex(method => method.identifier === code);
  if (selectedShippingMethod !== -1) {
    shippingMethods.unshift(shippingMethods.splice(selectedShippingMethod, 1)[0]);
  }
  return shippingMethods;
}
//# sourceMappingURL=getShippingMethods.js.map